import { supabase } from '@/core/database/supabase';
import { normalizePermissionsJson, permissionCatalog } from '@/modules/settings/permissions/catalog/permissionCatalog';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { RoleEditData } from '../types/rolesEdit.types';

type Row = Record<string, any>;

export const rolesEditService = {
  async getRoleById(id: string): Promise<RoleEditData> {
    const { data, error } = await supabase
      .from('roles')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    const role = data as Row;

    return {
      id: String(role.id),
      code: String(role.code || ''),
      name: String(role.name || ''),
      description: String(role.description || ''),
      permissionsJson: normalizePermissionsJson(role.permissions_json),
      isSystem: Boolean(role.is_system),
    };
  },

  getAvailablePermissions() {
    return permissionCatalog;
  },

  async updateRole(id: string, data: Partial<RoleEditData>): Promise<void> {
    await enforceSettingsPermission('settings.roles.update');
    const { error } = await supabase
      .from('roles')
      .update({
        name: data.name?.trim(),
        description: data.description?.trim() || null,
        permissions_json: data.permissionsJson || {},
        updated_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (error) throw error;
  },
};
